import { createIcon } from '@chakra-ui/react';

export const FacebookUnlinked = createIcon({
  displayName: 'fbSolid',
  viewBox: '0 0 82 82.133',
  path: (
    <g
      id="Facebook_Solid"
      data-name="Facebook Solid"
      transform="translate(-0.133)"
    >
      <circle
        id="Ellipse_4"
        data-name="Ellipse 4"
        cx="41"
        cy="41"
        r="41"
        transform="translate(0.133)"
        fill="#fff"
      />
      <path
        id="Path_2101"
        data-name="Path 2101"
        d="M334.357-787.635l1.794-11.7H324.926v-7.593c0-3.2,1.568-6.321,6.6-6.321h5.1v-9.961a62.241,62.241,0,0,0-9.061-.791c-9.246,0-15.288,5.6-15.288,15.748v8.917H302v11.7h10.277v28.285a40.792,40.792,0,0,0,6.324.492,40.53,40.53,0,0,0,6.3-.3l.026-28.479h9.431"
        transform="translate(-278.246 840.991)"
        fill="#135cb0"
        fillRule="evenodd"
      />
    </g>
  ),
});
